// SiteUp: junta várias chamadas feitas no mesmo tick numa só, rodada no fim do
// tick (microtask). Serve para watchers que disparam juntos quando a rota muda
// duas props de uma vez: sem isto cada um fazia a sua busca no servidor.
export const coalesceInTick = fn => {
  let queued = false;
  return () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      fn();
    });
  };
};
